import { HttpResponse } from '@angular/common/http';

import { SecurePayUITokenizedCard } from '../../../types/secure-pay';
import { AccountInfo, MapData, User, Vehicle } from '../../core/models';

const ActionTypes = {
  GET_CURRENT_USER: `[USER] Get Current User`,
  GET_CURRENT_USER_SUCCESS: `[USER] Get Current User Success`,
  GET_CURRENT_USER_FAIL: `[USER] Get Current User Fail`,

  LOAD_CURRENT_USER: `[USER] Load Current User`,
  LOAD_CURRENT_USER_SUCCESS: `[USER] Load Current User Success`,
  LOAD_CURRENT_USER_FAIL: `[USER] Load Current User Fail`,

  SET_CURRENT_USER: `[USER] Set Current User`,
  SET_CURRENT_USER_PENDING_VEHICLES: `[USER] Set Current User Pending Vehicles`,

  GET_ACCOUNT_INFO: `[USER] Get Account Info`,
  GET_ACCOUNT_INFO_SUCCESS: `[USER] Get Account Info Success`,
  GET_ACCOUNT_INFO_FAIL: `[USER] Get Account Info Fail`,

  SAVE_ACCOUNT_INFO: `[USER] Save Account Info`,
  SAVE_ACCOUNT_INFO_SUCCESS: `[USER] Save Account Info Success`,
  SAVE_ACCOUNT_INFO_FAIL: `[USER] Save Account Info Fail`,

  SET_ACCOUNT_INFO: `[USER] Set Account Info`,

  LOAD_MAP_DATA: `[USER] Load Map Data`,
  LOAD_MAP_DATA_SUCCESS: `[USER] Load Map Data Success`,
  LOAD_MAP_DATA_FAIL: `[USER] Load Map Data Fail`,

  SAVE_MAP_DATA: `[USER] Save Map Data`,
  SAVE_MAP_DATA_SUCCESS: `[USER] Save Map Data Success`,
  SAVE_MAP_DATA_FAIL: `[USER] Save Map Data Fail`,

  CHECK_ACCESS_TOKEN: `[USER] Check Access Token`,
  SET_ACCESS_TOKEN: `[USER] Set Access Token`,
  CLEAR_ACCESS_TOKEN: `[USER] Clear Access Token`,

  SUBSCRIBE_TO_PREMIUM_PLAN: `[USER] Subscribe To Premium Plan`,
  SUBSCRIBE_TO_PREMIUM_PLAN_SUCCESS: `[USER] Subscribe To Premium Plan Success`,
  SUBSCRIBE_TO_PREMIUM_PLAN_FAIL: `[USER] Subscribe To Premium Plan Fail`,

  RENEW_USER_VEHICLES_SUBSCRIPTION: `[USER] Renew User Vehicles Subscription`,
  RENEW_USER_VEHICLES_SUBSCRIPTION_SUCCESS: `[USER] Renew User Vehicles Subscription Success`,
  RENEW_USER_VEHICLES_SUBSCRIPTION_FAIL: `[USER] Renew User Vehicles Subscription Fail`,

  LOGOUT: `[USER] Logout`,
};

export class GetCurrentUserAction {
  static type = ActionTypes.GET_CURRENT_USER;
}
export class GetCurrentUserSuccessAction {
  static type = ActionTypes.GET_CURRENT_USER_SUCCESS;

  constructor(public payload: HttpResponse<User> & { initializedFromStorage: boolean }) {
  }
}
export class GetCurrentUserFailAction {
  static type = ActionTypes.GET_CURRENT_USER_FAIL;

  constructor(public payload: any) {
  }
}




export class LoadCurrentUserAction {
  static type = ActionTypes.LOAD_CURRENT_USER;
}
export class LoadCurrentUserSuccessAction {
  static type = ActionTypes.LOAD_CURRENT_USER_SUCCESS;

  constructor(public payload: HttpResponse<User>) {
  }
}
export class LoadCurrentUserFailAction {
  static type = ActionTypes.LOAD_CURRENT_USER_FAIL;

  constructor(public payload: any) {
  }
}




export class SetCurrentUserAction {
  static type = ActionTypes.SET_CURRENT_USER;

  constructor(public payload: User) {
  }
}




export class SetCurrentUserPendingVehiclesAction {
  static type = ActionTypes.SET_CURRENT_USER_PENDING_VEHICLES;

  constructor(public payload: Vehicle[]) {
  }
}




export class GetAccountInfoAction {
  static type = ActionTypes.GET_ACCOUNT_INFO;
}

export class GetAccountInfoSuccessAction {
  static type = ActionTypes.GET_ACCOUNT_INFO_SUCCESS;

  constructor(public payload: AccountInfo) {
  }
}

export class GetAccountInfoFailAction {
  static type = ActionTypes.GET_ACCOUNT_INFO_FAIL;

  constructor(public payload: any) {
  }
}




export class SaveAccountInfoAction {
  static type = ActionTypes.SAVE_ACCOUNT_INFO;

  constructor(public payload: AccountInfo) {
  }
}

export class SaveAccountInfoSuccessAction {
  static type = ActionTypes.SAVE_ACCOUNT_INFO_SUCCESS;
}

export class SaveAccountInfoFailAction {
  static type = ActionTypes.SAVE_ACCOUNT_INFO_FAIL;

  constructor(public payload: any) {
  }
}




export class SetAccountInfoAction {
  static type = ActionTypes.SET_ACCOUNT_INFO;

  constructor(public payload: AccountInfo) {
  }
}




export class LoadMapDataAction {
  static type = ActionTypes.LOAD_MAP_DATA;

  constructor(public payload?: any) {
  }
}
export class LoadMapDataSuccessAction {
  static type = ActionTypes.LOAD_MAP_DATA_SUCCESS;

  constructor(public payload: MapData) {
  }
}
export class LoadMapDataFailAction {
  static type = ActionTypes.LOAD_MAP_DATA_FAIL;

  constructor(public payload: any) {
  }
}




export class SaveMapDataAction {
  static type = ActionTypes.SAVE_MAP_DATA;

  constructor(public payload?: any) {
  }
}
export class SaveMapDataSuccessAction {
  static type = ActionTypes.SAVE_MAP_DATA_SUCCESS;

  constructor(public payload: MapData) {
  }
}
export class SaveMapDataFailAction {
  static type = ActionTypes.SAVE_MAP_DATA_FAIL;

  constructor(public payload: any) {
  }
}




export class CheckAccessTokenAction {
  static type = ActionTypes.CHECK_ACCESS_TOKEN;

  constructor(public payload?: any) {
  }
}
export class SetAccessTokenAction {
  static type = ActionTypes.SET_ACCESS_TOKEN;

  constructor(public payload: string) {
  }
}
export class ClearAccessTokenAction {
  static type = ActionTypes.CLEAR_ACCESS_TOKEN;

  constructor(public payload?: any) {
  }
}




export class SubscribeToPremiumPlanAction {
  static type = ActionTypes.SUBSCRIBE_TO_PREMIUM_PLAN;
}
export class SubscribeToPremiumPlanSuccessAction {
  static type = ActionTypes.SUBSCRIBE_TO_PREMIUM_PLAN_SUCCESS;
}
export class SubscribeToPremiumPlanFailAction {
  static type = ActionTypes.SUBSCRIBE_TO_PREMIUM_PLAN_FAIL;

  constructor(public payload: any) {
  }
}




export class RenewUserVehiclesSubscriptionAction {
  static type = ActionTypes.RENEW_USER_VEHICLES_SUBSCRIPTION;
  constructor(
    public payload: {
      vehicleIds: number[];
      cardData: SecurePayUITokenizedCard;
    },
  ) {
  }
}
export class RenewUserVehiclesSubscriptionSuccessAction {
  static type = ActionTypes.RENEW_USER_VEHICLES_SUBSCRIPTION_SUCCESS;
  constructor(public payload: Vehicle[]) {
  }
}
export class RenewUserVehiclesSubscriptionFailAction {
  static type = ActionTypes.RENEW_USER_VEHICLES_SUBSCRIPTION_FAIL;
}




export class LogoutAction {
  static type = ActionTypes.LOGOUT;

  constructor(public payload?: any) {
  }
}
